<template>
    <customer-layout>
        <div>
            <!-- <div class="relative mt-2 child">
                <div class="flex justify-center">
                    <span class="object-cover p-1 bg-white border-2 border-pink-600 rounded-full shadow-md">
                        <inertia-link href="/user/profile" class="w-1/12">
                            <img v-if="user.profile_photo_path != null" class="w-16 rounded-full" :src="`../storage/${user.profile_photo_path}`" alt="user" />
                            <img v-else class="w-16 rounded-full" src="img/portrait.svg" alt="user" />
                        </inertia-link>
                    </span>
                </div>
            </div> -->
            <!-- <div class="w-full px-4 mx-auto md:max-w-screen-xl">
                <progress v-if="diamonds" class="progress" :value="diamonds" max="100"></progress>
            </div> -->
            <div class="w-full px-4 pb-12">
                <ul class="flex flex-wrap w-full mx-auto md:max-w-screen-xl">
                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-blue-500 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[0] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('Causativity Remedy') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t("When people don't behave as you expected, or as you would like, you feel bad.") }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/cause" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-green-400 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[1] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('Determination Remedy') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t('Asking might embarrass you, and because of this, you might find yourself doing things that others should have done.') }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/determination" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-indigo-500 rounded-lg shadow-md h-44">
                        <div v-if="done !=  null && done[2] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('Self-discipline Remedy') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t("Sometimes you leave nuances unmanaged that could become tomorrow's serious problems.") }}</p>
                                
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/discipline" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-indigo-900 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[3] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('Finance Remedy') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t('The money you make, or have today, depends on the value you have created for other people.') }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/financial" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-pink-500 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[4] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('HR remedy') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t('Four activities could guide you in improving your people management style.') }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/hr" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-yellow-500 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[5] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('Motivation program') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t('The people who get the most results are the ones who believe in themselves the most.') }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/motive" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-green-500 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[6] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{$t('Stress Management Program') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t("When people don't behave the way you expected, or how you might like, you feel bad.") }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/stress" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-blue-900 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[7] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('Organization / Time Management') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t('Organizational difficulties can be traced back to difficulties in the following four areas.') }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/time" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-pink-400 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[8] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">{{ $t('Comprehension Remedy') }}</h4>
                                <p class="text-sm text-white font-extralight">{{ $t('There are three habits that, when not trained, could lead to difficulties in interpersonal relationships.') }}</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/understanding" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>


                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-green-500 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[9] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">Vendite</h4>
                                <p class="text-sm text-white font-extralight">Le difficoltà di vendita possono essere fatte risalire a problematiche nelle sei aree che seguono...</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/sales" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="w-full p-2 sm:w-6/12 lg:w-4/12" style="min-height:200px;">
                        <div class="relative flex flex-row w-full px-4 py-6 mb-4 text-white bg-indigo-500 rounded-lg shadow-md h-44">
                            <div v-if="done !=  null && done[10] == 1" class="ribbon ribbon-top-left"><span>{{ $t('completed') }}</span></div>
                            <div class="w-2/12">
                                <img src="/img/osm-coin.png" alt="gem" class="p-2">
                            </div>
                            <div class="w-10/12">
                                <h4 class="font-bold text-white">Espansività e timidezza</h4>
                                <p class="text-sm text-white font-extralight">La timidezza spesso è nemica della crescita professionale...</p>
                                <div class="flex justify-between mt-2 w-12/12">
                                    <inertia-link href="/programs/shyness" class="inline-block w-auto px-4 py-1 mt-4 text-xs font-semibold text-black uppercase bg-white rounded-full">{{ $t('start') }}</inertia-link>
                                    <div class="flex flex-row px-2 mt-4 bg-transparent border border-white border-solid rounded-full">
                                        <img src="/img/osmcoin-white.svg" alt="gem" class="h-6 pr-1">
                                        <span class="text-lg font-semibold text-white">0.5x</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </customer-layout>
</template>

<script>
import CustomerLayout from '../Layouts/CustomerLayout.vue';

export default {
  props: ["user", "current", "diamonds", "doing", "done"],
  components: {
    CustomerLayout
  },
};
</script>


<style>
.progress {
    box-sizing: border-box;
    display: inline-block;
    height: 0.50rem!important;
    width: 100%;
    left: 0;
    border-radius: 4px!important;
    -webkit-appearance:none;
    vertical-align: 0;
    z-index: 1;
}

progress::-webkit-progress-bar {
    background-color: #F7F7F7;
}
progress::-webkit-progress-value {
    background: rgba(213, 63, 140, 1);
    background: linear-gradient(90deg, rgba(213, 63, 140, 1) 0%, rgba(233, 29, 114, 1) 100%); 
    border-radius: 4px!important;
}
progress::-moz-progress-bar {
    background:rgba(213, 63, 140, 1);
    background: linear-gradient(90deg, rgba(213, 63, 140, 1) 0%, rgba(233, 29, 114, 1) 100%);
    border-radius: 4px!important; 
}


.ribbon {
  width: 120px;
  height: 120px;
  overflow: hidden;
  position: absolute;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 2px solid #10b981;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 200px;
  padding: 8px 0;
  background-color: #10b981;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 12px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
}
 
/* top left*/
.ribbon-top-left {
  top: -1px;
  left: -1px;
}
.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}
.ribbon-top-left::before {
  top: 0;
  right: 0;
}
.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}
.ribbon-top-left span {
  right: -25px;
  top: 30px;
  transform: rotate(-45deg);
}
 

 

 



</style>